import { Button, LogIn01, useStyletron } from "@mezo-org/mezo-clay";
import React, { forwardRef } from "react";
const DisconnectedTrigger = forwardRef((props, ref) => {
    const { onClick, children, ...restProps } = props;
    const [, theme] = useStyletron();
    return (React.createElement(Button, { startEnhancer: React.createElement(LogIn01, { color: "currentColor", size: theme.sizing.scale600 }), overrides: {
            Root: {
                props: { ref },
            },
        }, size: "small", shape: "pill", onClick: onClick, ...restProps }, children));
});
export default DisconnectedTrigger;
//# sourceMappingURL=DisconnectedTrigger.js.map